import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { push } from 'connected-react-router';
import * as actionCreators from '../action-creators';
import { Actions } from '../../actions';
import { CheckAdditionalEmails } from '../action-creators';
import { CHECK_ADDITIONAL_EMAILS } from '../actions';
import AppState from '@webapp/store/state';
import isEqualAccounts from '@webapp/utils/auth/is-equal-accounts';

export const checkAdditionalEmails = (
  action$: Observable<Actions>,
  $state: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CheckAdditionalEmails>(CHECK_ADDITIONAL_EMAILS),
    withLatestFrom($state),
    map(([{ userData }, state]) => {
      const prevAccounts = [
        ...(state.user.profile?.additionalEmails ?? []),
        ...(state.user.profile?.additionalTelephones ?? []),
      ];
      const currentAccounts = [
        ...(userData.additionalEmails ?? []),
        ...(userData.additionalTelephones ?? []),
      ];

      if (isEqualAccounts(prevAccounts, currentAccounts)) {
        return new actionCreators.UpdateUser(userData);
      }

      return push({ pathname: '/user/confirm-changes', state: { userData } });
    })
  );
